@if (mapItem(); as mapItem) {
    <ui-detail-view-container>
        <ui-prevention-details-header [mapItem]="mapItem"/>
        <ui-prevention-details-audience [mapItem]="mapItem"/>
        <ui-prevention-details-content [mapItem]="mapItem"/>
        <ui-prevention-details-framework [mapItem]="mapItem"/>
        <ui-prevention-details-contact [mapItem]="mapItem"/>
    </ui-detail-view-container>
}
